<div
  class="list-item-container"
  [ngClass]="
    imagePaddingClass +
    ' ' +
    centerAlignLineClass +
    ' ' +
    selectedClass +
    ' ' +
    mobileFullWidthImageClass +
    ' ' +
    leftContentClass +
    ' ' +
    centerContentClass
  "
>
  <div class="list-item-left-section-box" #leftSection>
    <ng-content select="[leftSection]"></ng-content>
  </div>
  <div class="list-item-text-box">
    <ng-content select="[tagSection]"></ng-content>
    <div
      *ngIf="primaryLineContainsContent"
      class="basin-body line-height-normal primary-line basin-display-flex basin-align-items-center"
    >
      {{ primaryLine }}
      <div #primaryLineSection>
        <ng-content select="[primaryLineSection]"></ng-content>
      </div>
    </div>
    <div
      *ngIf="secondaryLineContainsContent"
      class="sub-line secondary-line basin-display-flex basin-align-items-center"
    >
      {{ secondaryLine }}
      <div #secondaryLineSection>
        <ng-content select="[secondaryLineSection]"></ng-content>
      </div>
    </div>
    <div
      *ngIf="tertiaryLineContainsContent"
      class="sub-line tertiary-line basin-display-flex basin-align-items-center"
    >
      {{ tertiaryLine }}
      <div #tertiaryLineSection>
        <ng-content select="[tertiaryLineSection]"></ng-content>
      </div>
    </div>
  </div>
  <div class="line-height-normal list-item-center-section-box" #centerSection>
    <ng-content select="[centerSection]"></ng-content>
  </div>
  <div class="list-item-right-section-box" #rightSection>
    <ng-content select="[rightSection]"></ng-content>
  </div>
</div>
